import React from 'react';
import { Box, Paper, Typography, useTheme } from '@mui/material';
import { CARD_PADDING } from '../caseStatusTheme';

type Props = { closingReason: string };

const ClosedCard = ({ closingReason }: Props) => {
  const theme = useTheme();

  return (
    <Paper elevation={1} sx={{ p: 0, overflow: 'hidden' }} data-testid="closed-reason-card">
      <Box
        sx={{
          p: CARD_PADDING,
          backgroundColor: `${theme.palette.success.main}14`,
          textAlign: 'center',
        }}
      >
        <Typography
          variant="h5"
          data-testid="closed-reason-text"
          sx={{ fontWeight: 700, color: theme.palette.success.main }}
        >
          {closingReason}
        </Typography>
      </Box>
    </Paper>
  );
};

export default ClosedCard;